import type { IDataState } from "@/store/modules/data";
import _ from "@/boot/lodash";
import { DataModules } from "@/store/modules/data/modules";
import type { ActionTree, GetterTree } from "vuex";
import type { IState } from "@/store";
import type { ApiPathGetter } from "@/models/api";
import type { IClient, IUser } from "@upmind-automation/types";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath:
    (s, g, rS, { isAdminContext, isMockClientContext }): ApiPathGetter =>
    ({
      clientId,
      userId
    }: {
      clientId?: IClient["id"];
      userId?: IUser["id"];
    }) => {
      const admin = `api/admin/${
        clientId
          ? `clients/${clientId}`
          : userId
          ? `users/${userId}`
          : "organisation"
      }/whitelisted_ips`;
      const client = `api/clients/${clientId}/whitelisted_ips`;
      const contextual =
        isAdminContext && !isMockClientContext() ? admin : client;
      return { client, admin, contextual };
    }
};

export const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath(_.pick(payload, ["clientId", "userId"]))
          .contextual,
        storeModule: DataModules.IP_WHITELIST
      },
      { root: true }
    );
  },
  create: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/create",
      {
        ...payload,
        path: getters.apiPath(_.pick(payload, ["clientId", "userId"]))
          .contextual,
        storeModule: DataModules.IP_WHITELIST
      },
      { root: true }
    );
  },
  update: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/update",
      {
        ...payload,
        path: `${
          getters.apiPath(_.pick(payload, ["clientId", "userId"])).contextual
        }/${payload.id}`,
        storeModule: DataModules.IP_WHITELIST
      },
      { root: true }
    );
  },
  remove: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/remove",
      {
        ...payload,
        path: `${
          getters.apiPath(_.pick(payload, ["clientId", "userId"])).contextual
        }/${payload?.id}`,
        storeModule: DataModules.IP_WHITELIST
      },
      { root: true }
    );
  },
  openAddUpdateIPModal: ({ dispatch }, payload) => {
    return dispatch(
      "ui/open/windowModal",
      {
        config: {
          component: () =>
            import(
              "@/components/app/global/ipWhitelist/ipWhitelistManageModal.vue"
            ),
          width: 480,
          ...payload
        }
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
